// extracted by mini-css-extract-plugin
export default {"wrapper":"N6-z"};